import ContactPlaceholder from '$tablet-app/src/app/components/Contact/ContactPlaceholder';
import Text from '$tablet-app/src/app/components/Text';
import useRecordThumbnail from '$tablet-app/src/app/images/hooks/useRecordThumbnail';
import { color, palette } from '$tablet-app/src/app/theme';
import { Button } from '@akin-home/buttons/native';
import { ContactModel } from '@akin-home/contacts';
import { isWebBuild } from '@akin-home/utils/native';
import React, { FC, useMemo } from 'react';
import styled from 'styled-components/native';

interface Props {
  contact: ContactModel;

  onPressView?: (contact: ContactModel) => void;
  onPressCall?: (contact: ContactModel) => void;
  onPressVideoCall?: (contact: ContactModel) => void;
  onPressMessage?: (contact: ContactModel) => void;
}

const ContactRow: FC<Props> = (props) => {
  const {
    contact,
    onPressView,
    onPressCall,
    onPressMessage,
    onPressVideoCall,
  } = props;

  const { uri } = useRecordThumbnail({ record: contact });

  const actions = useMemo(
    () => ({
      onPressView: onPressView ? () => onPressView(contact) : undefined,
      onPressCall: onPressCall ? () => onPressCall(contact) : undefined,
      onPressMessage: onPressMessage
        ? () => onPressMessage(contact)
        : undefined,
      onPressVideoCall: onPressVideoCall
        ? () => onPressVideoCall(contact)
        : undefined,
    }),
    [contact, onPressView, onPressCall, onPressMessage, onPressVideoCall]
  );

  return (
    <Row>
      <Label onPress={actions.onPressView}>
        {uri ? (
          <StyledImage source={{ uri }} />
        ) : (
          <ContactPlaceholder
            initial={contact.name.substring(0, 1)}
            height={48}
            width={48}
          />
        )}
        <Text>{contact.name}</Text>
      </Label>

      <ButtonGroup>
        {!isWebBuild() && contact.hasPhoneNumber() ? (
          <Button
            variant="secondary"
            onPress={actions.onPressCall}
            iconColor={palette.primary_90}
            icon="phone"
            iconSize={20}
          />
        ) : null}

        <Button
          variant="secondary"
          onPress={actions.onPressVideoCall}
          iconColor={palette.Secondary_blue}
          icon="video"
          iconSize={20}
        />

        {!isWebBuild() && contact.hasPhoneNumber() && (
          <Button
            variant="secondary"
            icon="comment-lines"
            iconColor={palette.Bright_green}
            onPress={actions.onPressMessage}
          />
        )}

        <Button
          variant="text"
          icon="chevron-right"
          iconColor={color.text}
          iconSize={20}
          onPress={actions.onPressView}
        />
      </ButtonGroup>
    </Row>
  );
};

const StyledImage = styled.Image`
  width: 48px;
  height: 48px;
  border-radius: 15px;
`;

const Row = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom-width: 1px;
  border-bottom-color: ${palette.lightGrey1};
`;

const Label = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
`;

const ButtonGroup = styled.View`
  flex-direction: row;
  align-items: center;
  gap: 15px;
`;

export default ContactRow;
